var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnLockAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45763 4.59012L2.37142 3.4063L2.30384 3.46637C1.0729 4.61332 0.279973 6.15327 0.0613696 7.82148C-0.157234 9.48969 0.212143 11.182 1.106 12.6073C1.99986 14.0327 3.36236 15.1022 4.95927 15.6319C6.55618 16.1616 8.28775 16.1185 9.85629 15.5099C11.4248 14.9013 12.7324 13.7653 13.5541 12.2971C14.3759 10.829 14.6605 9.12041 14.3591 7.46516C14.0576 5.80991 13.189 4.31137 11.9024 3.22715C10.6159 2.14294 8.99182 1.54078 7.30942 1.5242V0L4.22348 2.40268L7.32194 4.80286V3.1335C8.43287 3.15225 9.51349 3.49893 10.428 4.12998C11.3425 4.76103 12.0501 5.6483 12.4618 6.68028C12.8736 7.71227 12.9711 8.84293 12.7422 9.93019C12.5133 11.0174 11.9681 12.0128 11.1752 12.7912C10.3823 13.5695 9.37706 14.0962 8.28575 14.3049C7.19444 14.5136 6.06578 14.3952 5.04159 13.9644C4.01741 13.5336 3.14339 12.8097 2.52937 11.8837C1.91535 10.9577 1.58873 9.87087 1.59054 8.75977C1.58834 7.98561 1.74744 7.21947 2.0577 6.5102C2.36795 5.80092 2.82256 5.16405 3.39255 4.64018L3.45763 4.59012Z",
    fill: "#3E9936"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnLockAccount);
export default __webpack_public_path__ + "static/media/IconUnLockAccount.82007a17e7accbcd037a971bb5ee8dbc.svg";
export { ForwardRef as ReactComponent };